import { useQuery } from '@tanstack/react-query'
import { type BookingCancellationRefundEligibilityDto } from '../../../qourses-api-client'
import { qoursesApi } from '../../api/qourses.tsx'

export default function useGetBookingRefundOptions(
  bookingId: string,
  overrideTOS?: boolean,
): {
  bookingCancellationOptions: BookingCancellationRefundEligibilityDto
  isLoading: boolean
  isError: boolean
  refetch: () => void
  isRefetching: boolean
} {
  const {
    data: bookingCancellationOptions,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useQuery(['booking', bookingId, 'refundOptions'], async () => {
    return qoursesApi.payment.paymentControllerGetBookingCancellationRefundEligibilityV1(
      bookingId,
      overrideTOS,
    )
  })

  return { bookingCancellationOptions, isLoading, isError, refetch, isRefetching }
}
